"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyQuestionedDefaultValue = exports.notifyQuestionedSchema = void 0;
const zod_1 = require("zod");
exports.notifyQuestionedSchema = zod_1.z.object({
    notify_creditor_ids: zod_1.z.array(zod_1.z.string()),
});
const defaultValue = {
    notify_creditor_ids: ['CODIGO_1', 'CODIGO_2'],
};
exports.NotifyQuestionedDefaultValue = JSON.stringify(defaultValue, null, '\t');
